import { render, staticRenderFns } from "./LifeStylesSelect.vue?vue&type=template&id=168ba604&lang=pug&"
import script from "./LifeStylesSelect.vue?vue&type=script&lang=js&"
export * from "./LifeStylesSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports